











import { Component, Prop, Vue } from 'vue-property-decorator';
import { TotalSegment } from '@/store/models';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';

@Component({
    components: {},
})
export default class TotalsComp extends Vue {
    @Prop() private totalSegments!: TotalSegment[];

    get loading(): boolean {
        return cart.loadingFlags.totals;
    }

    get shippingFreeTitle(): string {
        return checkout.shippingFree.title;
    }

    get shippingFreeDescription(): string {
        return checkout.shippingFree.description;
    }

    public isShippingFree() {
        let free = false;

        this.totalSegments.forEach((totalSegment: TotalSegment) => {
            if (totalSegment.code === 'shipping') {
                if (totalSegment.value === 0) {
                    free = true;
                }
            }
        });

        return free;
    }
}
